<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%">
      <el-dialog title="巡检计划" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="任务名称" prop="rwmc">
              <el-input type="type" placeholder="任务名称" class="from-el-input" v-model.trim="ruleForm.rwmc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="负责人" prop="fzr">
              <el-select filterable v-model.trim="ruleForm.fzr" class="from-el-input" placeholder="选择负责人">
                <el-option v-for="(item,i) in fzrList" :key="i" :label="item.username" :value="item.username">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="巡检点" prop="ydblists">
              <el-select multiple collapse-tags filterable v-model.trim="ruleForm.ydblists" class="from-el-input"
                placeholder="选择淤地坝">
                <el-option v-for="(item,i) in ydblist" :key="i" :label="item.ydbName" :value="item.ydbName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="巡检日期" prop="xjDate">
              <el-date-picker class="from-el-input" v-model.trim="ruleForm.xjDate" value-format="yyyy-MM-dd" type="dates"
                placeholder="巡检日期"></el-date-picker>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="状态" prop="xjzt">
              <el-select v-model.trim="ruleForm.xjzt" class="from-el-input" placeholder="状态">
                <el-option v-for="(item,i) in ztlist" :key="i" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button round @click="empty()" type="warning">取消</el-button>
            <el-button round v-if="state=='xz'" type="primary" @click="deteRmine('ruleForm')">保 存</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>

<script>
  import {
    ydbjbxxQuery,
    userlist,
    xjjhSave,
    dictioninfo
  } from '@/api/api.js'
  export default {
    props: {
      mystate: Array
    },
    data() {
      return {
        dialogVisible: true,
        fzrList: [],
        ydblist: [],
        ztlist: [],
        ruleForm: {
          rwmc: '',
          fzr: '',
          ydblists: [],
          xjDate: '',
          xjzt: '',
        },
        rules: {
          rwmc: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            },
            {
              min: 1,
              max: 50,
              message: "长度在 1 到 50 个字符",
              trigger: "blur"
            }
          ],
          fzr: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            }
          ],
          ydblists: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            }
          ],
          xjDate: [{
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          }],
          xjzt: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            },
            {
              min: 1,
              max: 50,
              message: "长度在 1 到 50 个字符",
              trigger: "blur"
            }
          ],
        },

        state: 'xz',
        row: null,
      };
    },
    created() {
      //初始化数据
    },
    components: {},
    methods: {
      //获取巡检状态数字字典
      getxjztinfo() {
        let params = {
          type: 'xjzt',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.ztlist = res.data;
        })
      },
      empty() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      deteRmine(formName) { //确定
        this.$refs[formName].validate(valid => {
          if (valid) {
            let xjdStr='';
            if (this.ruleForm.ydblists.length === 1) {
              xjdStr = this.ruleForm.ydblists[0];
            } else{
              for (let i=0; i<this.ruleForm.ydblists.length-1; i++) {
                xjdStr += this.ruleForm.ydblists[i]+';';
              }
              xjdStr += this.ruleForm.ydblists[this.ruleForm.ydblists.length-1];
            }

            let params = {
              ydbXjjhMc: this.ruleForm.rwmc, //巡检计划名称
              ydbFxxczrr: this.ruleForm.fzr, //负责人名称
              ydbNames: xjdStr, //巡检点
              ydbXjrqList: this.ruleForm.xjDate, //巡检日期
              status: this.ruleForm.xjzt, //状态
            };
            xjjhSave(params).then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: "提示",
                  message: "提交成功",
                  type: "success"
                });
                this.dialogVisible = false;
                this.$emit("adddata", {
                  dialogVisible: this.dialogVisible
                });
              } else {
                this.$notify({
                  title: "提示",
                  message: res.message,
                  type: "warning"
                });
              }
            })
          }
        });
      },
    },
    mounted() {
      this.getxjztinfo();
      // this.state = 'xz';

      let params = {
        allowPage: false
      };
      ydbjbxxQuery(params).then((res) => {
        this.ydblist = res.data;
      });
      userlist({}).then((res) => {
        this.fzrList = res.data;
      });
    }
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 600px;
  }

  >>>.el-dialog__body {
    height: 300px;
    overflow: auto;
  }

  >>>.el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  >>>.el-select {
    width: 100%;
  }

  .trees {
    width: 98%;
    float: left;
    max-height: 300px;
    height: 60px;
    line-height: 30px;
    padding-left: 2%;
    margin-top: 5px;
  }
</style>
